(function () {
  function pad(n) {
    return String(n).padStart(2, '0');
  }

  // ponytail: local browser midnight Sunday; upgrade path = fixed US/Eastern week boundary
  function nextDealWeekEnd() {
    var now = new Date();
    var end = new Date(now);
    var day = now.getDay();
    var daysUntilSunday = day === 0 ? 0 : 7 - day;
    end.setDate(now.getDate() + daysUntilSunday);
    end.setHours(23, 59, 59, 999);
    if (end.getTime() <= now.getTime()) {
      end.setDate(end.getDate() + 7);
    }
    return end;
  }

  function resolveEnd(endRaw) {
    if (endRaw) {
      var configured = new Date(endRaw);
      if (!Number.isNaN(configured.getTime()) && configured.getTime() > Date.now()) {
        return configured;
      }
    }
    return nextDealWeekEnd();
  }

  function initCountdown(root) {
    var end = resolveEnd(root.getAttribute('data-countdown-end'));
    var daysEl = root.querySelector('[data-hp-countdown-days]');
    var hoursEl = root.querySelector('[data-hp-countdown-hours]');
    var minsEl = root.querySelector('[data-hp-countdown-mins]');
    var secsEl = root.querySelector('[data-hp-countdown-secs]');
    if (!daysEl || !hoursEl || !minsEl || !secsEl) return;

    function tick() {
      var diff = end.getTime() - Date.now();
      if (diff < 0) {
        end = nextDealWeekEnd();
        diff = end.getTime() - Date.now();
      }
      var totalSecs = Math.max(0, Math.floor(diff / 1000));
      daysEl.textContent = pad(Math.floor(totalSecs / 86400));
      hoursEl.textContent = pad(Math.floor((totalSecs % 86400) / 3600));
      minsEl.textContent = pad(Math.floor((totalSecs % 3600) / 60));
      secsEl.textContent = pad(totalSecs % 60);
    }

    tick();
    window.setInterval(tick, 1000);
  }

  function initIndustryCarousel(root) {
    var track = root.querySelector('[data-tcb-hp-ind-track]');
    var nextBtn = root.querySelector('[data-tcb-hp-ind-next]');
    if (!track || !nextBtn) return;

    nextBtn.addEventListener('click', function () {
      var card = track.querySelector('.tcb-hp__ind-card');
      var step = card ? card.offsetWidth + 14 : 234;
      track.scrollBy({ left: step, behavior: 'smooth' });
    });
  }

  document.querySelectorAll('[data-tcb-hp-countdown]').forEach(initCountdown);
  document.querySelectorAll('[data-tcb-hp-ind-carousel]').forEach(initIndustryCarousel);
})();
